import { GMFTreeItem } from '../gmf';
import ILayerWithLegend from './ilayerwithlegend';
import Layer from './layer';

type LayerPMTilesOptions = {
  isDefaultChecked?: boolean;
  disclaimer?: string;
  metadataUrl?: string;
  opacity?: number;
  minResolution?: number;
  maxResolution?: number;
  style?:string,
};

class LayerPMTiles extends Layer implements ILayerWithLegend {
  /**
   * This class is a used in the state of the application, which will be accessed behind a javascript proxy.
   * This means that each modification made to its properties must come from outside,
   * because they have to be made through the proxy, so that the modification can be listen.
   * Therefore, this class must not contain any method which is updating a value directly
   * For example, any method doing <this.xxx = value> is forbidden here, because the modification be known from the proxy
   */

  public source: string;
  public style?: string;
  public minResolution?: number;
  public maxResolution?: number;

  // Legend attributes
  public legend: boolean;
  public legendImage?: string | undefined;
  public isLegendExpanded: boolean;
  public wasLegendExpanded: boolean;

  constructor(id: number, name: string, order: number, source: string, style?: string, options?:  LayerPMTilesOptions) {
    let opts = options ?? {};
    opts = LayerPMTiles.isGMFTreeItem(opts) ? LayerPMTiles.getOptionsFromGMFTreeItem(opts) : opts;
    super(id, name, order, opts);
    this.source = source;
    this.style = style;
    this.minResolution = opts.minResolution;
    this.maxResolution = opts.maxResolution;
    this.legend = true;
    this.legendImage = 'TODO';
    this.isLegendExpanded = false;
    this.wasLegendExpanded = false;
  }

  clone() {
    const options = {
      isDefaultChecked: this.isDefaultChecked,
      metadataUrl: this.metadataUrl,
      disclaimer: this.disclaimer,
      opacity: this.opacity,
      minResolution: this.minResolution,
      maxResolution: this.maxResolution,
      style: this.style,
    };
    const clonedObject = new LayerPMTiles(this.id, this.name, this.order, this.source, this.style, options);
    clonedObject.activeState = this.activeState;
    return clonedObject;
  }

  hasRestrictedResolution() {
    return (this.minResolution && this.minResolution !== 0) || (this.maxResolution && this.maxResolution !== 999999999);
  }

  isVisibleAtResolution(resolution: number) {
    if (resolution === undefined || resolution === null || !this.hasRestrictedResolution()) {
      return true;
    }
    return resolution >= (this.minResolution ?? -1) && resolution <= (this.maxResolution ?? Infinity);
  }

  private static isGMFTreeItem(options: GMFTreeItem | LayerPMTilesOptions): options is GMFTreeItem {
    return 'id' in options;
  }

  private static getOptionsFromGMFTreeItem(options: GMFTreeItem): LayerPMTilesOptions {
    return {
      isDefaultChecked: options.metadata?.isChecked,
      metadataUrl: options.metadata?.metadataUrl,
      disclaimer: options.metadata?.disclaimer,
      opacity: 1, // TODO REG : Set default opacity

      minResolution: options.minResolutionHint,
      maxResolution: options.maxResolutionHint
    };
  }
}

export default LayerPMTiles;
